function labelToBranch(label: string): string {
  return (
    "feat/" +
    label
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
  );
}

interface BranchBarProps {
  label?: string;
  issueNumber?: number;
  intoBranch?: string;
}

export default function BranchBar({
  label = "Pitch a guest / topic",
  issueNumber = 143,
  intoBranch = "main",
}: BranchBarProps) {
  const fromBranch = labelToBranch(label);
  return (
    <div className="flex items-center gap-2 flex-wrap mb-6">
      <span
        className="font-montserrat font-semibold text-white rounded-full px-3 py-0.5"
        style={{ fontSize: "13px", letterSpacing: "0.1em", backgroundColor: "#2da44e" }}
      >
        OPEN
      </span>
      <span
        className="font-montserrat text-stone-500"
        style={{ fontSize: "14px" }}
      >
        #{issueNumber} wants to merge from
      </span>
      <span
        className="font-montserrat font-medium rounded-full px-3 py-0.5"
        style={{
          fontSize: "13px",
          letterSpacing: "0.04em",
          backgroundColor: "#fce7e9",
          color: "#6d0016",
          border: "1px solid #f0c8cc",
        }}
      >
        {fromBranch}
      </span>
      <span className="font-montserrat text-stone-500" style={{ fontSize: "14px" }}>
        into
      </span>
      <span
        className="font-montserrat font-medium rounded-full px-3 py-0.5"
        style={{
          fontSize: "13px",
          letterSpacing: "0.04em",
          backgroundColor: "#e6f4ea",
          color: "#1a7f37",
          border: "1px solid #b4dfc4",
        }}
      >
        {intoBranch}
      </span>
    </div>
  );
}
